import { useEffect, useState } from "react";
import { Input } from "./ui/input";
import { useApp } from "@/lib/app-context";
import { inr } from "@/lib/api";

export const ProductPicker = ({ onPick, testid = "product-picker", placeholder = "Search product by name, SKU or barcode" }) => {
  const { api, branchId } = useApp();
  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);
  useEffect(() => {
    if (q.length < 2) return setRows([]);
    const t = setTimeout(() => api.get("/products", { params: { q, branch_id: branchId, status: "active", limit: 15 } }).then((r) => setRows(r.data)), 250);
    return () => clearTimeout(t);
  }, [q, api, branchId]);
  return (
    <div className="relative">
      <Input data-testid={testid} value={q} onChange={(e) => setQ(e.target.value)} placeholder={placeholder} />
      {rows.length > 0 && (
        <div className="absolute z-50 mt-1 w-full max-h-64 overflow-y-auto rounded-md border bg-white shadow-lg">
          {rows.map((p) => (
            <button key={p.id} type="button" data-testid={`${testid}-option-${p.erp_code}`} className="w-full text-left px-3 py-2 text-sm hover:bg-emerald-50 flex justify-between gap-2"
              onClick={() => { onPick(p); setQ(""); setRows([]); }}>
              <span><b>{p.name}</b> <span className="font-mono text-xs text-muted-foreground">{p.erp_code}</span></span>
              <span className="text-xs text-muted-foreground">{inr(p.effective_offline_price)} · {p.stock.available} {p.unit}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
